import { IconSVG } from '../types';

export const PauseCircle = ({ size, style }: IconSVG) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 40 40"
      style={style}
    >
      <path
        fill="currentColor"
        d="M16.667 26.667c.472 0 .868-.16 1.187-.48.32-.319.48-.715.48-1.187V15c0-.472-.16-.868-.48-1.188-.32-.319-.715-.479-1.187-.479-.473 0-.868.16-1.188.48-.32.319-.479.715-.479 1.187v10c0 .472.16.868.48 1.187.319.32.715.48 1.187.48zm6.666 0c.473 0 .868-.16 1.188-.48.32-.319.479-.715.479-1.187V15c0-.472-.16-.868-.48-1.188-.319-.319-.714-.479-1.187-.479-.472 0-.868.16-1.187.48-.32.319-.48.715-.48 1.187v10c0 .472.16.868.48 1.187.32.32.715.48 1.187.48zm-3.333 10c-2.305 0-4.472-.438-6.5-1.313-2.028-.875-3.792-2.062-5.292-3.562S5.521 28.528 4.646 26.5 3.333 22.305 3.333 20c0-2.306.438-4.472 1.313-6.5.875-2.028 2.062-3.792 3.562-5.292s3.264-2.687 5.292-3.562 4.195-1.313 6.5-1.313c2.306 0 4.472.438 6.5 1.313 2.028.875 3.792 2.062 5.292 3.562s2.687 3.264 3.562 5.292 1.313 4.194 1.313 6.5c0 2.305-.438 4.472-1.313 6.5-.875 2.028-2.062 3.792-3.562 5.292s-3.264 2.687-5.292 3.562-4.194 1.313-6.5 1.313zm0-3.334c3.722 0 6.875-1.291 9.458-3.875 2.584-2.583 3.875-5.736 3.875-9.458 0-3.722-1.291-6.875-3.875-9.458C26.875 7.958 23.722 6.667 20 6.667c-3.722 0-6.875 1.291-9.458 3.875C7.958 13.125 6.667 16.278 6.667 20c0 3.722 1.291 6.875 3.875 9.458 2.583 2.584 5.736 3.875 9.458 3.875z"
      />
    </svg>
  );
};
